import { Wifi, WifiOff } from 'lucide-react';

interface ConnectionStatusProps {
  isConnected: boolean;
}

const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ isConnected }) => {
  return (
    <div className="absolute top-4 right-4 z-50">
      <div className="p-2 rounded-lg backdrop-blur-sm bg-black/20">
        {isConnected ? (
          <Wifi className="w-5 h-5 text-green-400" />
        ) : (
          <WifiOff className="w-5 h-5 text-red-400" />
        )}
      </div>
    </div>
  );
};

export default ConnectionStatus;
